import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '@/view/homePage.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import PageOne from '@/view/PageOne.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/homePage'
  },
  {
    path: '/homePage',
    component: homePage
  },
  {
    path: '/HeaderComponent',
    component: HeaderComponent
  },
  {
    path: '/PageOne',
    component: PageOne
  },

]

// const router = new VueRouter({
//   routes
// })
const  router = new VueRouter({
  routes,

  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 60 }, // 可设置偏移量
        behavior: 'smooth'
      }
    }
  }
})
export default router
